import { fork, put, take } from 'redux-saga/effects';

import { AUTHENTICATION_FINISHED } from '../../modals/addPaymentMethodModal/AddPaymentMethodModal.actions';
import { authenticationCompleteWorker } from '../../modals/addPaymentMethodModal/AddPaymentMethodModal.sagas';
import {
    SHOW_PROCESING_PAYMENT_MODAL_AUTHENTICATION_REQUIRED,
    SHOW_PROCESING_PAYMENT_MODAL_ERROR,
    SHOW_PROCESING_PAYMENT_MODAL_INITIATED
} from '../../modals/processingPaymentModal/ProcessingPaymentModal.actions';

export type PostRepaymentPaymentIntentResponseData = {
    payment_processor: string;
    payment_intent: {
        secret: string | null;
    };
    payment_instruction_id: string;
    stripe_client_secret: string | null;
    checkout_redirect_link: string | null;
};

export function* confirmCheckoutPaymentIntent(response: {
    data: PostRepaymentPaymentIntentResponseData;
}) {
    const checkout_redirect_link = response.data.checkout_redirect_link;
    if (!checkout_redirect_link) {
        // @ts-ignore
        return yield put({
            type: SHOW_PROCESING_PAYMENT_MODAL_ERROR
        });
    }
    yield put({
        type: SHOW_PROCESING_PAYMENT_MODAL_AUTHENTICATION_REQUIRED,
        authenticationIframeURL: checkout_redirect_link
    });
    yield fork(authenticationCompleteWorker);
    yield take(AUTHENTICATION_FINISHED);
    yield put({
        type: SHOW_PROCESING_PAYMENT_MODAL_INITIATED,
        paymentInstructionId: response.data.payment_instruction_id
    });
}
